var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWatermarking = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#31373D",
  d: "M15.374 13.37 13.316 7h-2.268L8.99 13.356 7.352 7H5l2.702 9.926h2.324l2.128-6.58 2.114 6.58h2.282L19.252 7h-2.268z"
})));
export default SvgWatermarking;